<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	[rowId]="rowId"
	firstColumnProperty="user.firstName"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="addedBy"
				[defaultFilterLabel]="filterLabels.addedBy"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="4">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.addedBy }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('addedBy')"
								data-automation-id="added-by-input"
								(ngModelChange)="dataSet.filter('addedBy', filterLabels.addedBy, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.notes }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('note')"
								data-automation-id="notes-input"
								(ngModelChange)="dataSet.filter('note', filterLabels.notes, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.dateAdded }}</mat-label>
							<input
								matInput
								[matDatepicker]="dateAddedPicker"
								[ngModel]="dataSet.filter('dateAdded')"
								(ngModelChange)="dataSet.filter('dateAdded', filterLabels.dateAdded, $event)"
								data-automation-id="date-added-input"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="dateAddedPicker"
								data-automation-id="date-added-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker #dateAddedPicker data-automation-id="date-added-datepicker"></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.noteType }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('noteType')"
								(ngModelChange)="dataSet.filter('noteType', filterLabels.noteType, $event, noteTypeOptions)"
								data-automation-id="note-type-picker"
							>
								@for (option of noteTypeOptions; track option.value) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'note-type-' + option.value">
										{{ option.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		<ng-container>
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add Note"
					(click)="navigateToAddDeviceNote()"
					data-automation-id="add-device-button"
					i18n-label="@@deviceNotes-addDeviceNote"
				>
				</app-data-set-action-button>
			</div>
		</ng-container>
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getAllDeviceNotesLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSortActive="dateAdded"
				matSortDirection="desc"
				matSort
				[hidden]="loadingService.isLoading(getAllDeviceNotesLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="addedBy">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceNotes-AddedBy" class="column-added-by">
						Added By
					</th>
					<td mat-cell *matCellDef="let row" class="column-added-by">{{ row.user | name }}</td>
				</ng-container>

				<ng-container matColumnDef="note">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceNotes-Notes" class="column-note">
						Notes
					</th>
					<td mat-cell *matCellDef="let row; let i = index" class="column-note">
						<div class="note-container" [attr.id]="'note-container-' + i">
							<span class="note-text" [attr.id]="'note-text-' + i">
								{{ row.deviceNote.note }}
							</span>
							<span class="caret-container">
								<mat-icon
									svgIcon="sl-down-caret"
									class="note-down-carrot"
									[attr.id]="'note-down-carrot-' + i"
								></mat-icon>
								<mat-icon svgIcon="sl-up-caret" class="note-up-carrot" [attr.id]="'note-up-carrot-' + i"></mat-icon>
							</span>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="dateAdded">
					<th
						mat-header-cell
						*matHeaderCellDef
						mat-sort-header
						i18n="@@deviceNotes-DateAdded"
						class="column-date-added"
					>
						Date Added
					</th>
					<td mat-cell *matCellDef="let row" class="column-date-added">
						{{
							row.deviceNote.utcEntryTime
								| date
									: 'mediumDate'
									: timeZoneService.utcOffset(row.deviceNote.utcEntryTime, row.deviceNote.locationTimeZone)
						}},
						{{
							row.deviceNote.utcEntryTime
								| date
									: 'shortTime'
									: timeZoneService.utcOffset(row.deviceNote.utcEntryTime, row.deviceNote.locationTimeZone)
						}}
					</td>
				</ng-container>

				<ng-container matColumnDef="noteType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceNotes-NoteType" class="column-note-type">
						Note Type
					</th>
					<td mat-cell *matCellDef="let row" class="column-note-type">{{ row.deviceNote.noteType }}</td>
				</ng-container>

				<ng-container matColumnDef="photos">
					<th mat-header-cell *matHeaderCellDef i18n="@@deviceNotes-Photos" class="column-photos">Photos</th>
					<td mat-cell *matCellDef="let row" class="column-photos">
						@if (row.deviceNotePhotos.length === 0) {
							<div>-</div>
						} @else {
							<mat-icon
								class="device-note-photos"
								svgIcon="sl-image"
								matTooltip="{{ notePhotosTooltip }}"
								(click)="showPhotos(row.deviceNotePhotos)"
								data-automation-id="show-photos-button"
							></mat-icon>
						}</td
				></ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
